import { defineMessages } from 'react-intl';

/** The texts of "SoundCloud extras" (design service-extras a1, a2). */
export const soundCloudExtrasMessages = defineMessages({
  label: { id: 'app.sml.servicesPanel.soundCloudExtras.label', defaultMessage: 'SoundCloud extras' },
  song: { id: 'app.sml.servicesPanel.soundCloudExtras.song', defaultMessage: 'Song' },
  ready: {
    id: 'app.sml.servicesPanel.soundCloudExtras.ready',
    defaultMessage: 'The master, the cover, the title and the release day go up.',
  },
  connect: {
    id: 'app.sml.servicesPanel.soundCloudExtras.connect',
    defaultMessage: 'Connect SoundCloud. Then MUSIC24 can upload this song to it.',
  },
  noMaster: {
    id: 'app.sml.servicesPanel.soundCloudExtras.noMaster',
    defaultMessage: 'Add the master of this song first.',
  },
  masterProcessing: {
    id: 'app.sml.servicesPanel.soundCloudExtras.masterProcessing',
    defaultMessage: 'The master is still processing. You can upload it when it is ready.',
  },
  waitsReleaseDay: {
    id: 'app.sml.servicesPanel.soundCloudExtras.waitsReleaseDay',
    defaultMessage: 'MUSIC24 uploads it on {date} at {time}, {sharing, select, private {private} other {public}}.',
  },
  uploading: {
    id: 'app.sml.servicesPanel.soundCloudExtras.uploading',
    defaultMessage: 'MUSIC24 sends the song to SoundCloud. You can leave this page.',
  },
  unsure: {
    id: 'app.sml.servicesPanel.soundCloudExtras.unsure',
    defaultMessage: 'The upload stopped after the file went out. Check SoundCloud before you try again.',
  },
  chipOnReleaseDay: {
    id: 'app.sml.servicesPanel.soundCloudExtras.chip.onReleaseDay',
    defaultMessage: 'On release day',
  },
  chipOnSoundCloud: { id: 'app.sml.servicesPanel.soundCloudExtras.chip.onSoundCloud', defaultMessage: 'On SoundCloud' },
  upload: { id: 'app.sml.servicesPanel.soundCloudExtras.action.upload', defaultMessage: 'Upload to SoundCloud' },
  change: { id: 'app.sml.servicesPanel.soundCloudExtras.action.change', defaultMessage: 'Change' },
  addMaster: { id: 'app.sml.servicesPanel.soundCloudExtras.action.addMaster', defaultMessage: 'Add the master' },
});
